module.exports = __webpack_public_path__ + "img/202211.f6bdfd03.png";